import { renderGraph } from '../functions/render-graph';
import { TOOLTIP_MODE } from '../constants';

class Graph {

	constructor(name) {
		this.config = {
			name: name,
			data: [],
			height: 400,
			margins: [30, 40, 30, 40],
			panels: [],
			plotLines: [],
			plotBands: [],
			tooltipMode: TOOLTIP_MODE.INDIVIDUAL,
			legendEnabled: true,
			xAxis: null
		};

		// When graph is rendered, will be set to the element where all events are captured within the
		// graph. Can be accessed to add custom events or similar.
		this.eventCapturingBox = null;

		// When graph is rendered, this will be a function that may be called to hide tooltips. Can
		// be useful for some external events.
		this.hideTooltipFn = null;
	}

	data(data) {
		this.config.data = data;
		return this;
	}

	height(h) {
		// h can be a numeric pixel value or a function which takes width and returns height
		this.config.height = h;
		return this;
	}

	margin(margins) {
		this.config.margins = margins;
		return this;
	}

	panels(panels) {
		this.config.panels = panels;
		return this;
	}

	plotLines(plotLines) {
		this.config.plotLines = plotLines;
		return this;
	}

	plotBands(plotBands) {
		this.config.plotBands = plotBands;
		return this;
	}

	tooltipMode(mode) {
		this.config.tooltipMode = mode;
		return this;
	}

	legendEnabled(isEnabled) {
		this.config.legendEnabled = isEnabled;
		return this;
	}

	xAxis(axis) {
		this.config.xAxis = axis;
		return this;
	}

	render(container) {
		renderGraph(this, container);
	}

	hideTooltips() {
		if (typeof this.hideTooltipFn === 'function') {
			this.hideTooltipFn();
		}
	}

}

export function graph(name) {
	return new Graph(name);
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/graph.js